import { LanguageActionTypes, SWITCH_LANGUAGE} from 'redux/language/types'
import { Language } from 'types/language'

export const switchLanguage = (lang: Language): LanguageActionTypes => ({
    type: SWITCH_LANGUAGE,
    payload: lang
})